import { Card, EmptyState, Skeleton } from '@ui/themed';
import type { PropsWithChildren } from 'react';

// Handles loading and error states
export function SparkSuspense(
  props: PropsWithChildren<{
    isError: boolean;
    errorMessage: string;
    onReload: () => void;
    isLoading: boolean;
  }>,
) {
  if (props.isError) {
    return (
      <Card>
        <EmptyState kind="error" description={props.errorMessage} onRetry={props.onReload} />
      </Card>
    );
  }

  if (props.isLoading) {
    return <Skeleton />;
  }

  return props.children;
}
